import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Icon } from '@atoms';
import { Flex, Typography, Button } from '@mixins';
import { getCloudinaryImageLinkBySize } from '@helpers/common';
import { formatTime } from '@helpers/time';
import { dayjs } from '@utils';
import { theme } from '@styles';

import RoomImage from '@assets/images/RoomImage.png';
import { ReactComponent as Edit } from '@assets/svgs/Edit.svg';

import { arrayOf, exact, func, number, string } from 'prop-types';

const GlobalAccessRequests = ({ requests, onCancelClick, onEditRequestClick }) => {
  const { currentLocation } = useSelector(store => store.locationStore);

  const requestsBlock = useMemo(
    () =>
      requests.map(({ id, firstDate, secondDate, time, location: { image, title } }) => {
        const dateTime = dayjs(firstDate).set('hour', time.split(':')[0]).set('minute', time.split(':')[1]);
        const isActive = dayjs(dateTime).isSameOrAfter(dayjs());

        return (
          <Flex 
            width="100%"
            mb="20px" 
            minHeight="85px" paddingBottom='20px' borderBottom="1px solid #EFECE6" borderRadius="2px" key={id}>
            <Flex
              width="100%"
              maxWidth="140px"
              height="auto"
              background={`url(${getCloudinaryImageLinkBySize(image, 140) || RoomImage}) center`}
              backgroundSize="cover"
            />
            <Flex width="100%" alignItems="center" display="grid" gridTemplateColumns="1fr 1.5fr 1fr auto" px={30}>
              <Flex flexDirection="column" pr={10}>
                <Typography variant="diatype-500" fontSize={[10, 10, 12, 16]} color={theme.color.gray[600]}>
                  {title}
                </Typography>
              </Flex>
              <Flex flexDirection="column" pr={10}>
                <Typography variant="diatype-400" fontSize={[10, 10, 12, 14]} color={theme.color.gray[300]}>
                  {`${dayjs(firstDate).tz('UTC').format('MMMM DD, YYYY')} - 
                ${dayjs(secondDate).tz('UTC').format('MMMM DD, YYYY')}`}
                </Typography>
              </Flex>
              <Flex flexDirection="column" pr={10}>
                <Typography variant="diatype-400" fontSize={[10, 10, 12, 14]} color={theme.color.gray[300]}>
                  {formatTime(dateTime, currentLocation.timeFormat, '')}
                </Typography>
              </Flex>
              <Flex alignItems="center" minWidth={['80px', '80px', '100px', '160px']} justifyContent="space-between">
                {isActive && (
                  <>
                    <Icon
                      pointer
                      onClick={onEditRequestClick(id)}
                      color={theme.color.black}
                      width="15px"
                      height="15px"
                      SVG={Edit}
                />
                    <Button 
                      textAlign="end" 
                      color={theme.color.mintMinded[900]} py={[15, 18, 21, 24]} onClick={onCancelClick(id)}>
                      Cancel
                    </Button>
                  </>
              )}
              </Flex>
            </Flex>
          </Flex>
        );
      }),
    [requests, currentLocation.timeZone],
  );

  return requestsBlock;
};

GlobalAccessRequests.propTypes = {
  onCancelClick: func.isRequired,
  onEditRequestClick: func.isRequired,
  requests: arrayOf(
    exact({
      id: number,
      startDate: string,
      endDate: string,
      time: string,
      location: exact({
        title: string,
        timeFormat: string,
        timeZone: string,
      }),
    }),
  ),
};

GlobalAccessRequests.defaultProps = {
  requests: [],
};

export default GlobalAccessRequests;
